import React from 'react'
import { useTranslation } from 'react-i18next'
import {observer} from 'mobx-react'
import {useInjection} from 'dna-react-ioc'

import { THasIoCIdentifier } from '@/types'
import {Modal} from '@/components'
import {Ecospend} from '../../Ecospend'
import {TEcospendStore} from '@/pages/components'
import styles from './EcospendModal.scss'

export const EcospendModal = observer((props: THasIoCIdentifier) => {
    const { t } = useTranslation()
    const store = useInjection<TEcospendStore>(props.injectableIdentifier)

    return <Modal
        title={t('EcospendModal.ecospendModalTitle')}
        className={styles.ecospendModal}
        open={store.isEcospendModalVisible}
        onCancel={store.closeEcospendModal}
        footer={null}
    >
        <Ecospend injectableIdentifier={props.injectableIdentifier} />
    </Modal>
})
